import { StartDayFromSchedule } from "@/app/constants/configuration/startDayFromSchedule"
import { TimesheetScheduleMode } from "@/app/constants/configuration/timesheetScheduleMode"
import { TimesheetSettlementType } from "@/app/constants/configuration/timesheetSettlementType"

export const START_DAY_OPTIONS: Array<StartDayFromSchedule> = [
  StartDayFromSchedule.StartDayFromScheduleOption,
  StartDayFromSchedule.StartDayAfterFirstActivityInDayOption,
]

export const TIMESHEET_SCHEDULE_MODES: Array<TimesheetScheduleMode> = [
  TimesheetScheduleMode.AutoPrepareScheduleFromCalculation,
  TimesheetScheduleMode.StartDayFromScheduleOption,
]

export const TIMESHEET_SETTLEMENT_TYPES: Array<TimesheetSettlementType> = [
  TimesheetSettlementType.OneMonth,
  TimesheetSettlementType.TwoMonths,
  TimesheetSettlementType.ThreeMonths,
  TimesheetSettlementType.FourMonths,
]

export const WEEK_FREE_DAYS: Array<number> = [1, 4, 3, 2, 5, 6]
export const MINUTES_OPTIONS: Array<number> = [0, 15, 30, 45]
export const WORKTIME_LIMIT_HOURS_OPTIONS: Array<number> = [0, 1, 2, 3]
export const NIGHTTIME_START_HOURS_OPTIONS: Array<number> = [21, 22, 23]
export const HOLIDAY_START_HOURS_OPTIONS: Array<number> = Array.from({ length: 24 }, (_, i) => i)
